import React, { useState } from "react";
import { HomePageExplore } from "../../../data/homepage-explore";
import HighlightText from "../HomePage/HighlightText";
import CourseCard from "../../common/CourseCard";

const tabsNames = [
  "Free",
  "New to coding",
  "Most poupular",
  "Skill paths",
  "Career paths",
];

function ExploreMode(props) {
  const [currentTab, setCurrentTab] = useState(tabsNames[0]);
  const [courses, setCourses] = useState(HomePageExplore[0].courses);
  // console.log("Text",typeof(courses))
  const [currentCard, setCurrentCard] = useState(
    HomePageExplore[0].courses[0].heading
  );

  const setMyCards = (value) => {
    setCurrentTab(value);
    const result = HomePageExplore.filter((course) => course.tag === value);
    setCourses(result[0].courses);
    setCurrentCard(result[0].courses[0].heading);
  };

  return (
    <div className="mt-5 relative mb-14">
      <div className="text-4xl font-semibold text-center">
        Unlock the
        <HighlightText text={"Power of code"} />
      </div>
      <p className="text-center text-richblack-300 text-lg font-semibold mt-1">
        Learn to build anything you can imagine
      </p>

      <div className="flex flex-row w-full md:rounded-full rounded-2xl bg-richblack-800 mb-5 mt-5 border border-richblack-600 p-1">
        {tabsNames.map((element, index) => {
          return (
            <div
              className={`md:text-[16px] text-[12px] flex items-center gap-2 
                            ${
                              currentTab === element
                                ? "bg-richblack-900 text-richblack-5 font-medium"
                                : "text-richblack-200"
                            } rounded-full transition-all duration-200 cursor-pointer hover:bg-richblack-700 hover:text-richblack-5 md:px-7 md:py-2 px-2 py-4 text-center`}
              key={index} onClick={() => {
                setMyCards(element)
              }}>
              {element}
            </div>
          );
        })}
      </div>
        <div className="lg:h-40"></div>
      {/* Card */}
      <div className="flex lg:flex-row flex-col lg:gap-x-20 lg:gap-y-0 gap-y-10 mt-2 justify-between items-center lg:-translate-y-[50%] lg:-translate-x-[25%] lg:absolute w-full">
        {
          // -translate-y-[50%] -translate-x-[15%]
            courses.map((element,index)=>{
                return (
                    <div key={index}>
                        <CourseCard
                        cardData = {element}
                        currentCard = {currentCard}
                        setCurrentCard = {setCurrentCard}
                        />
                    </div>
                )
            })
        }
      </div>

    </div>
  );
}

export default ExploreMode;
